import client from '../httpClient';

const getLineReceptionListApi = async (userId) => {
  const res = await client.get(`/users/lineReceptions/${userId}`);
  return res;
};

export default getLineReceptionListApi;
